import { TrlPillPending } from './TrlPillPending';

export { TrlPillPending } from './TrlPillPending';
export default TrlPillPending;
